import React, { FC } from 'react';
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from 'recharts';
import { useTheme } from 'styled-components';
import CustomPolarTick from './CustomPolarGrid/CustomPolarGrid';
import CustomShape from './CustomShape/CustomShape';
import Dot from './Dot/Dot';

interface IChartData {
  challenge: string;
  low: number;
  high: number;
  value: number;
}

interface IEffectRadarChart {
  data: IChartData[];
  threshold_values?: {
    high: number;
    low: number;
    medium: number;
  };
}

const EffectRadarChart: FC<IEffectRadarChart> = ({ data, threshold_values }) => {
  const theme = useTheme();

  const max = Math.ceil(Math.max(...data.map(({ value }) => value)));

  return (
    <ResponsiveContainer width="100%" height={480}>
      <RadarChart {...{ data }}>
        <PolarGrid />
        <PolarAngleAxis
          dataKey="challenge"
          tickSize={12}
          fontSize={16}
          fontWeight={500}
          tick={data => <CustomPolarTick {...data} />}
        />
        <PolarRadiusAxis domain={[0, max + 1]} axisLine={false} tickLine={false} tick={false} />
        <Radar
          dataKey="low"
          stroke={theme.colors.accent.red[100]}
          strokeDasharray="10"
          shape={({ points, stroke, strokeDasharray }) => (
            <CustomShape {...{ points, stroke, strokeDasharray }} />
          )}
          isAnimationActive={false}
        />
        <Radar
          dataKey="high"
          stroke={theme.colors.accent.green[100]}
          strokeDasharray="10"
          shape={({ points, stroke, strokeDasharray }) => (
            <CustomShape {...{ points, stroke, strokeDasharray }} />
          )}
          isAnimationActive={false}
        />
        <Radar
          dataKey="value"
          dot={({ cx, cy, key, payload }) => (
            <Dot value={payload.value} {...{ key, cx, cy }} threshold_values={threshold_values} />
          )}
          stroke={theme.colors.neutral.primary[50]}
          strokeWidth="2"
          shape={({ points, stroke, strokeWidth }) => (
            <CustomShape {...{ points, stroke, strokeWidth }} />
          )}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default EffectRadarChart;
